import React, { useState } from 'react';
import styles from './Step4_LegalCheck.module.scss';
import Button from '../../ui/Button/Button';
import { trackEvent } from '../../../utils/analytics';

const Step4LegalCheck = ({ onNextStep, initialNeedsSearch = true }) => {
  const [needsSearch, setNeedsSearch] = useState(initialNeedsSearch);

  const handleSelectOption = (value) => {
    setNeedsSearch(value);
  };

  const handleNext = () => {
    trackEvent('select_item', {
      item_list_name: 'legal_check',
      items: [
        {
          item_id: needsSearch ? 'legal_check_yes' : 'legal_check_no',
          item_name: needsSearch ? 'З юридичною перевіркою' : 'Без перевірки',
          price: needsSearch ? 3000 : 0,
        }
      ]
    });
    onNextStep({ needsSearch });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <p className={styles.subtitle}>
          Перед поданням заявки до УКРНОІВІ рекомендуємо перевірити вашу торговельну марку на наявність вже зареєстрованих або раніше поданих схожих назв.
        </p>
      </div>

      {/* Info Blocks: What is it & What are the risks */}
      <div className={styles.infoGrid}>
        <div className={styles.infoBlock}>
          <div className={styles.blockHeader}>
            <span className={styles.blockIcon}>🔍</span>
            <h3 className={styles.blockTitle}>Що таке юридична перевірка?</h3>
          </div>
          <ul className={styles.pointsList}>
            <li className={styles.pointItem}>
              <span className={styles.pointBullet}>✓</span>
              <span><strong>Пошук за всіма базами:</strong> перевірка відкритих та закритих баз зареєстрованих ТМ і поданих заявок в Україні.</span>
            </li>
            <li className={styles.pointItem}>
              <span className={styles.pointBullet}>✓</span>
              <span><strong>Аналіз схожості:</strong> виявлення тотожних або схожих до ступеня змішування знаків (за звучанням, графікою та змістом).</span>
            </li>
            <li className={styles.pointItem}>
              <span className={styles.pointBullet}>✓</span>
              <span><strong>Офіційний висновок:</strong> рекомендації патентного повіреного щодо зниження ризиків відмови або варіантів доопрацювання знаку.</span>
            </li>
          </ul>
        </div>

        <div className={styles.warningBlock}>
          <div className={styles.blockHeader}>
            <span className={styles.blockIcon}>⚠️</span>
            <h3 className={styles.warningTitle}>Чим загрожує подання без перевірки?</h3>
          </div>
          <ul className={styles.pointsList}>
            <li className={styles.warningItem}>
              <span className={styles.warningBullet}>✕</span>
              <span><strong>Втрата 15–16 місяців:</strong> експертиза триває понад рік. Якщо буде відмова через схожість, весь цей час втрачається назавжди.</span>
            </li>
            <li className={styles.warningItem}>
              <span className={styles.warningBullet}>✕</span>
              <span><strong>Втрата держзборів:</strong> державні збори за подання та експертизу (від 4 000 до 15 000+ грн) не повертаються за жодних умов.</span>
            </li>
            <li className={styles.warningItem}>
              <span className={styles.warningBullet}>✕</span>
              <span><strong>Ризик позовів та ребрендингу:</strong> конфлікт із чужою ТМ може призвести до вимоги знищення продукції та відшкодування збитків.</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Options Cards */}
      <div className={styles.optionsSection}>
        <h3 className={styles.sectionHeading}>Оберіть варіант подання:</h3>
        <div className={styles.cardsContainer}>
          {/* Option 1: With search */}
          <div
            className={`${styles.optionCard} ${styles.recommended} ${needsSearch ? styles.selected : ''}`}
            onClick={() => handleSelectOption(true)}
          >
            <div className={styles.badge}>Рекомендовано</div>
            <div className={styles.cardTopRow}>
              <h4 className={styles.cardTitle}>Повна юридична перевірка</h4>
            </div>
            <div className={styles.cardPrice}>+ 3 000 ₴</div>
            <p className={styles.cardDesc}>
              Повний пошук за базами, юридичний висновок та оцінка ризиків перед поданням заявки. Захист від втрати держзборів і часу.
            </p>
          </div>

          {/* Option 2: Without search */}
          <div
            className={`${styles.optionCard} ${!needsSearch ? styles.selected : ''}`}
            onClick={() => handleSelectOption(false)}
          >
            <div className={styles.cardTopRow}>
              <h4 className={styles.cardTitle}>Подання без перевірки</h4>
            </div>
            <div className={styles.cardPrice}>0 ₴</div>
            <p className={styles.cardDesc}>
              Подання заявки без попереднього пошуку. Розумію та беру на себе ризики можливої відмови УКРНОІВІ або заперечень третіх осіб.
            </p>
          </div>
        </div>
      </div>

      {/* Notice about payment stages */}
      <div className={styles.paymentNotice}>
        {needsSearch ? (
          <span>
            💡 <strong>Порядок оплати з перевіркою:</strong> оплата розбивається на 3 етапи. Перший етап — лише вартість перевірки (<strong>3 000 грн</strong>), другий етап — підготовка та подання заявки, третій етап — отримання свідоцтва.
          </span>
        ) : (
          <span>
            💡 <strong>Порядок оплати без перевірки:</strong> стандартна оплата у 2 етапи (перший етап — перед підготовкою та поданням заявки, другий етап — після отримання свідоцтва).
          </span>
        )}
      </div>

      <div className={styles.buttonWrapper}>
        <Button
          variant="primary"
          onClick={handleNext}
        >
          Перейти до фінального розрахунку
        </Button>
      </div>
    </div>
  );
};

export default Step4LegalCheck;
